import { toast } from "sonner";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { loginService } from "../services/auth.service";
import { useAuth } from "../../../providers/AuthProvider";
import { setAuthSessionUser } from "../../../api/authSession";

export const useLogin = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  const login = async (username: string, password: string): Promise<void> => {
    try {
      setLoading(true);
      const res = await loginService(username, password);
      const authUser = res?.user ?? null;
      if (authUser) {
        setAuthSessionUser(authUser);
        setUser(authUser);
      }
      toast.success("با موفقیت وارد شدید");
      navigate("/home", { replace: true });
    } catch (err) {
      const message = err instanceof Error ? err.message : "ورود ناموفق بود";
      toast.error(message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { login, loading };
};
